module.exports = __webpack_public_path__ + "static/img/0.ed8f845.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/0.jpg
// module id = aUzH
// module chunks = 0